import React from 'react';
import './Rating.css';
import supabase from '../supabase';

// UPDATED: Cases count reduced for the third time
const mockUsers = [
  { id: 1, name: 'd1nero 🐩', casesOpened: 42, avatar: null },
  { id: 2, name: 'Vlada 🌸', casesOpened: 38, avatar: null },
  { id: 3, name: 'tikhon35s 👺', casesOpened: 35, avatar: null },
  { id: 4, name: 'fen ★', casesOpened: 31, avatar: null },
  { id: 5, name: 'Vlados', casesOpened: 29, avatar: null },
  { id: 6, name: 'Аня 💖', casesOpened: 26, avatar: null },
  { id: 7, name: 'rày 🕊️', casesOpened: 22, avatar: null },
  { id: 8, 'name': '✨🌶️', casesOpened: 19, avatar: null },
  { id: 9, name: 'Sergey', casesOpened: 15, avatar: null },
  { id: 10, name: 'Eva', casesOpened: 11, avatar: null },
];

const getMedal = (rank) => {
  if (rank === 1) return '🥇';
  if (rank === 2) return '🥈';
  if (rank === 3) return '🥉';
  return <span className="rank-number">{rank}</span>;
};

const getInitials = (name) => (name ? name.charAt(0).toUpperCase() : '?');

const Rating = () => {
  return (
    <div className="rating-page-container">
      <h1 className="rating-page-title">Рейтинг</h1>
      <ul className="rating-list">
        {mockUsers.map((user, index) => (
          <li key={user.id} className="rating-item">
            <div className="rating-item-rank">
              {getMedal(index + 1)}
            </div>
            <div className="rating-item-user">
              <div className="rating-avatar">
                {user.avatar ? <img src={user.avatar} alt={user.name} /> : getInitials(user.name)}
              </div>
              <span className="rating-name">{user.name}</span>
            </div>
            <div className="rating-item-cases">
              {user.casesOpened} кейсов
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default Rating; 